import ExportTableSeller from './ExportTableSeller';

export default ExportTableSeller;
